<lib-filters-base
    #filtersBase
    [filterForm]="filterForm"
    (filterChanged)="onFilterChanged($event)"
    [filter]="filter"
    suppressInitialRequest
    shortLayout>

    <div [formGroup]="filterForm">  <!-- required -->

        <ng-template #basicFilters>

            <div class="global-form-line-short-layout">

                <div class="form-field-container">
                    <lib-vitu-form-field-date
                        [formGroup]="filterForm"
                        formFieldName="localDateInterval"
                        label="Date Created"
                        [clearValue]="filter?._initialFilter?.localDateInterval"
                        restrictFuture
                        isFilter
                        readonly>
                    </lib-vitu-form-field-date>
                </div>
                
                <div class="form-field-container">
                    <lib-vitu-form-field-select
                        [formGroup]="filterForm"
                        formFieldName="statuses"
                        isFilter
                        multiple
                        label="Status"
                        [options]="dfmFileStatusList"
                        [showReset]="filtersBase.resetFieldVisible('statuses')"
                        (handleReset)="filtersBase.resetField('statuses')"
                        [spaceBetweenCapsOnLabels]="true">
                    </lib-vitu-form-field-select>
                </div>

            </div>

        </ng-template>

    </div>

</lib-filters-base>
